var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',[_c('template',{slot:"content"},[_c('help-content',{attrs:{"title":'ホームとランキング画面歩数が異なる原因'}},[_c('template',{slot:"content"},[_c('div',{staticClass:"text"},[_vm._v("\n          ホームに表示されている歩数をサーバーに送られてから、計算した結果がランキングとイベント画面に反映されます。そのため、ランキング／イベント画面の歩数が少し遅れて更新されます。\n        ")])])],2)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e440c70e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Help14.vue
// module id = IAfd
// module chunks = 0